import React, { useEffect } from 'react'
import { AuthRoute } from '@fs/zion-router'
import { useUser } from '@fs/zion-user'

const PromptSignInAuthRoute = ({ overlay, ...props }) => {
  const user = useUser()

  useEffect(() => {
    const { isOpen } = overlay
    const { userLoading } = user
    let subscribed = true

    if (!isOpen && !user?.signedIn && !userLoading) {
      if (subscribed) overlay.open()
    } else if (user?.signedIn) {
      overlay.close()
    }

    return () => {
      subscribed = false
    }
  }, [user, overlay])

  return user?.signedIn ? <AuthRoute {...props} /> : null
}

export default PromptSignInAuthRoute
